import React from 'react';
import classNames from 'classnames';

import './Avatar.css';

const Avatar = props => {
  const wrapperClasses = classNames('Avatar', props.className);
  const { imageClassName } = props;
  return (
    <div className={wrapperClasses}>
      <div className={imageClassName} style={{ backgroundImage: `url('${props.src}')` }} />
    </div>
  );
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.js